import React, { useState } from 'react';
import { StyledAddNewMember } from './MyTeam.styles';
import { GoArrowLeft } from 'react-icons/go';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';
import UploadImg from '../../molecules/UploadImg';
import ConfirmationBlock from '../ConfirmationBlock';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import { useNavigate } from 'react-router-dom';

const AddNewMember = () => {
  const { form } = useForm();
  const navigate = useNavigate();
  const [memberAdded, setMemberAdded] = useState(false);

  function handleSubmit() {
    setMemberAdded(true);
  }

  const RolesOptions = [
    {
      label: 'Super_Admin',
      value: 'Super_Admin',
    },
    {
      label: 'Manager',
      value: 'Manager',
    },
    {
      label: 'SALES OPERATION MANAGER',
      value: 'SALES OPERATION MANAGER',
    },
  ];

  const PermissionsOptions = [
    {
      label: 'Tasks.nav',
      value: 'Tasks.nav',
    },
    {
      label: 'Agents.nav',
      value: 'Agents.nav',
    },
    {
      label: 'Campaign Management.nav',
      value: 'Campaign Management.nav',
    },
    {
      label: 'Unibox.nav',
      value: 'Unibox.nav',
    },
    {
      label: 'Email Accounts.nav',
      value: 'Email Accounts.nav',
    },
    {
      label: 'Super Admin.nav',
      value: 'Super Admin.nav',
    },
  ];
  return (
    <StyledAddNewMember>
      {memberAdded ? (
        <ConfirmationBlock
          img={confirmImg}
          title="Member Added Successfully!"
          btns={<Button onClick={() => navigate('/my-team')}>Go back </Button>}
        />
      ) : (
        <div className="content-holder">
          <div className="head">
            <button onClick={() => window.history.back()}>
              <GoArrowLeft size={25} />
            </button>
            <div>
              <span className="heading">Add New Team Member!</span>
              <span className="text">Set up your team and control access through roles and permissions.</span>
            </div>
          </div>
          <Form form={form} onSubmit={handleSubmit}>
            <span className="title">Personal Info:</span>
            <UploadImg />
            <div className="input-wrap">
              <Form.Item
                type="text"
                label="First Name"
                rounded
                name="first_name"
                placeholder="Enter first name"
                rules={[
                  {
                    required: true,
                    message: ' First name is required',
                  },
                ]}>
                <Field />
              </Form.Item>
              <Form.Item
                type="text"
                label="Last Name"
                rounded
                name="last_name"
                placeholder="Enter last name"
                rules={[
                  {
                    required: true,
                    message: 'Last name is required',
                  },
                ]}>
                <Field />
              </Form.Item>
            </div>
            <Form.Item
              type="email"
              label="Email Address"
              rounded
              name="email"
              placeholder="Email Address"
              rules={[
                {
                  required: true,
                  message: ' Email is required',
                },
              ]}>
              <Field />
            </Form.Item>
            <span className="title">Roles & Permissions:</span>
            <div className="input-wrap last-wrapper">
              <Form.Item
                type="select"
                label="Roles"
                rounded
                name="roles"
                placeholder="Select role"
                options={RolesOptions}
                noMargin
                rules={[
                  {
                    required: true,
                    message: ' Role is required',
                  },
                ]}>
                <Field />
              </Form.Item>

              <Form.Item
                type="select"
                label="Roles"
                rounded
                name="roles"
                placeholder="Select role"
                options={PermissionsOptions}
                noMargin
                rules={[
                  {
                    required: true,
                    message: ' Role is required',
                  },
                ]}>
                <Field />
              </Form.Item>
            </div>
            <div className="btn-holder">
              <Button width="330px">Add Member</Button>
            </div>
          </Form>
        </div>
      )}
    </StyledAddNewMember>
  );
};

export default AddNewMember;
